// Axios
export { default as api } from '../services//api';
export type { ApiResponse } from '../services/api';
export { authHeader } from '../services//api';
// export * from './Layout'
// export { default as Button } from './Common/Button'

// Logo
export * from './Common/Logo';

// Icon
export * from './Common/Icons';
export { default as LoadingIcon } from './Common/Icons/LoadingIcon';

// RouteContex
export { default as RouteContext } from './Layout/RouteContext';
export type { RouteContextType } from './Layout/RouteContext';

// Layout
export { Layout } from './Layout';
export { default as PageContainer } from './Layout/PageContainer';
export type { RouterType } from './Layout';
// DndKit
export * from './Common/Dnd';

// Common
export { vi_VN } from './Common/locale';
export { default as ModalConfirm } from './Common/Modal/ModalConfirm';
export { ModalConfirmDelete } from './Common/Modal/ModalConfirmDelete';
export { Image } from './Common/Image';
export * from './Common/Upload';
export { default as Upload } from './Common/Upload';
export { ButtonFilter } from './Common/Button/ButtonFilter';
export * from './Common/Chart';
export * from './Common/CopyToClipboard';
export * from './Common/Editor';
export * from './Common/Map';
export * from './Common/TimePicker';
export * from './Common/TimePicker2';
export * from './Common/Loading';
export * from './Common/Upload/Upload2';
export * from './Common/Upload/UploadMultiImg';
export { default as NumberFormatter } from './Common/NumberFormatter';

// ui
export * from './ui/pagination';
export * from './ui/tag';
export * from './ui/modal';

// App Component
export * from './Common/ActionButton';
export { VerifiedStatus } from './Common/VerifiedStatus';
export { SwitchSync } from './Common/Switch';
export { default as UserInfo } from './Layout/UserInfo';

// Page
export { default as Login } from './Login';
export { default as Register } from './Login/Register';
export { default as Verification } from './Login/Verification';
export { default as CreateNewPass } from './Login/CreateNewPass';
export { default as ForgotPass } from './Login/ForgotPass';
export { default as ResetPassword } from './Login/ResetPassword';
export { default as Page404 } from './Layout/404';
export { default as PreLogin} from './Login/PreLogin';
export { default as ChangeDefaultPassword} from './Login/ChangeDefaultPassword';
export { default as forgotPassMerchantStep2} from './Login/ForgotPassMerchantStep2';
export * from './Common/Result';

export { default as PageLoading } from './Layout/PageLoading';

// Utils
export * from '../utils';

// Validations
export { vnPhoneNumberPattern } from '../validations';

export const TIME_FORMAT_DEFAULT = 'DD/MM/YYYY [-] hh:mmA';
export const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
